import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { OnlineProvider } from "@/contexts/OnlineContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AbbonamentoPage from "@/pages/AbbonamentoPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import AziendePage from "@/pages/AziendePage";
import PrivacyPage from "@/pages/PrivacyPage";
import DeleteAccountPage from "@/pages/DeleteAccountPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import WeekViewPage from "@/pages/WeekViewPage";
import HomePage from "@/pages/HomePage";
import RapportinoFormPage from "@/pages/RapportinoFormPage";
import RapportinoPrintPage from "@/pages/RapportinoPrintPage";
import RiepilogoPage from "@/pages/RiepilogoPage";
import AnagraficaDipendenti from "@/pages/AnagraficaDipendenti";
import AnagraficaCommesse from "@/pages/AnagraficaCommesse";
import DaSistemarePage from "@/pages/DaSistemarePage";
import DaInviarePage from "@/pages/DaInviarePage";
import RisorsePage from "@/pages/RisorsePage";
import ProgrammaPage from "@/pages/ProgrammaPage";
import QuadroAziendalePage from "@/pages/QuadroAziendalePage";
import ClientiPage from "@/pages/ClientiPage";
import UtentiPage from "@/pages/UtentiPage";
import SettingsPage from "@/pages/SettingsPage";
import ScanRapportinoPage from "@/pages/ScanRapportinoPage";
import ImportPage from "@/pages/ImportPage";
import TrashPage from "@/pages/TrashPage";
import ProfilePage from "@/pages/ProfilePage";
import PrintReportsPage from "@/pages/PrintReportsPage";
import ControlloOrePage from "@/pages/ControlloOrePage";
import DashboardCommessePage from "@/pages/DashboardCommessePage";
import DaVidimarePage from "@/pages/DaVidimarePage";
import StatistichePage from "@/pages/StatistichePage";
import LandingPage from "@/pages/LandingPage";
import { useAuth } from "@/contexts/AuthContext";

// Iter 66: radice pubblica → vetrina per i visitatori, app per chi è loggato
function RootGate() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-500 font-heading">Caricamento…</div>
      </div>
    );
  }
  if (user) return <Navigate to="/settimana" replace />;
  return <LandingPage />;
}

function App() {
  return (
    <div className="App">
      <OnlineProvider>
        <AuthProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootGate />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/demo" element={<LoginPage />} />
            <Route path="/registrati" element={<RegisterPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/elimina-account" element={<DeleteAccountPage />} />
            <Route path="/password-dimenticata" element={<ForgotPasswordPage />} />
            <Route path="/reimposta-password" element={<ResetPasswordPage />} />

            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/settimana" element={<WeekViewPage />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/lista" element={<DashboardPage />} />
              <Route path="/da-inviare" element={<DaInviarePage />} />
              <Route path="/risorse" element={<RisorsePage />} />
              <Route path="/programma" element={<ProgrammaPage />} />
              <Route path="/quadro" element={<QuadroAziendalePage />} />
              <Route path="/scansiona" element={<ScanRapportinoPage />} />
              <Route path="/import" element={<ImportPage />} />
              <Route path="/cestino" element={<TrashPage />} />
              <Route path="/profilo" element={<ProfilePage />} />
              <Route path="/stampe" element={<PrintReportsPage />} />
              <Route path="/controllo-ore" element={<ControlloOrePage />} />
              <Route path="/dashboard-commesse" element={<DashboardCommessePage />} />
              <Route path="/statistiche" element={<StatistichePage />} />
              <Route
                path="/da-vidimare"
                element={
                  <ProtectedRoute requireAdmin>
                    <DaVidimarePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/da-sistemare"
                element={
                  <ProtectedRoute requireAdmin>
                    <DaSistemarePage />
                  </ProtectedRoute>
                }
              />
              <Route path="/rapportino/new" element={<RapportinoFormPage />} />
              <Route path="/rapportino/:id" element={<RapportinoFormPage />} />
              <Route path="/riepilogo" element={<RiepilogoPage />} />
              <Route path="/abbonamento" element={<AbbonamentoPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/aziende" element={<AziendePage />} />
              <Route
                path="/anagrafica/dipendenti"
                element={<AnagraficaDipendenti />}
              />
              <Route
                path="/anagrafica/commesse"
                element={<AnagraficaCommesse />}
              />
              <Route
                path="/anagrafica/clienti"
                element={
                  <ProtectedRoute requireAdmin>
                    <ClientiPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/utenti"
                element={
                  <ProtectedRoute requireAdmin>
                    <UtentiPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/impostazioni"
                element={
                  <ProtectedRoute requireAdmin requireSettings>
                    <SettingsPage />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="/rapportino/:id/stampa"
              element={
                <ProtectedRoute>
                  <RapportinoPrintPage />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-right" />
          </BrowserRouter>
        </AuthProvider>
      </OnlineProvider>
    </div>
  );
}

export default App;
